export const ANALYTICS_PAGE_LOAD = 'ANALYTICS_PAGE_LOAD';
export const ANALYTICS_CLICK_EVENT = 'ANALYTICS_CLICK_EVENT';
export const ANALYTICS_CLICK_ORDER_SUMMARY_SCC = 'ANALYTICS_CLICK_ORDER_SUMMARY_SCC';
export const UPDATE_ANALYTICS_CLICK_EVENT = 'UPDATE_ANALYTICS_CLICK_EVENT';
export const DIGITAL_ANALYTICS_PAGE_LEVEL_DATA = 'DIGITAL_ANALYTICS_PAGE_LEVEL_DATA';
export const GET_ANALYTICS_CLICK_EVENT_STACK = 'GET_ANALYTICS_CLICK_EVENT_STACK';
export const PUT_ANALYTICS_CLICK_EVENT_STACK = 'PUT_ANALYTICS_CLICK_EVENT_STACK';
export const TOGGLE_SHIPPING_TYPE_ANALYTICS_ACTION = 'TOGGLE_SHIPPING_TYPE_ANALYTICS_ACTION';
export const PLCC_BANNER_UPDATE_DATA = 'PLCC_BANNER_UPDATE_DATA';
export const ANALYTICS_CLICK_GIFT_CARD_BANNER = 'ANALYTICS_CLICK_GIFT_CARD_BANNER';
export const GOOGLE_CAPTCHA_ANALYTICS_EVENT = 'GOOGLE_CAPTCHA_ANALYTICS_EVENT';
export const PLCC_CLICK_EVENT_ACTION = 'PLCC_CLICK_EVENT_ACTION';
export const TRIGGER_AUTH_ANALYTICS = 'TRIGGER_AUTH_ANALYTICS';
export const ANALYTICS_GUEST_EMAIL_OPTIN = 'ANALYTICS_GUEST_EMAIL_OPTIN';
export const ORDER_VARIANCE_SUBMIT_ORDER = 'ORDER_VARIANCE_SUBMIT_ORDER';
